import React, { MouseEvent, useState } from "react";
import { Text } from "@bookingcom/bui-react";
import useModalDialog from "hooks/useModalDialog";
import { useViewPriceDetailsController } from "./ViewPriceDetails.controller";
import styles from "./ViewPriceDetails.module.css";

type ViewPriceDetailsProps = {
  children: React.ReactNode;
};

export const ViewPriceDetails = ({ children }: ViewPriceDetailsProps) => {
  const [showPriceDetails, setShowPriceDetails] = useState<boolean>(false);
  const {
    text,
    modal: { title, closeAriaLabel }
  } = useViewPriceDetailsController();
  const Modal = useModalDialog();

  if (!text || !title || !closeAriaLabel || !children) return null;

  const handleClickViewPriceDetails = (e: MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    setShowPriceDetails(true);
  };

  const handleCloseModal = () => {
    setShowPriceDetails(false);
  };

  return (
    <>
      <a className={styles.link} href="#" onClick={handleClickViewPriceDetails}>
        <Text variant="body_2">{text}</Text>
      </a>
      <Modal title={title} closeAriaLabel={closeAriaLabel} onCloseTrigger={handleCloseModal} active={showPriceDetails}>
        {children}
      </Modal>
    </>
  );
};
